import { useNavigate } from "react-router-dom";
import videoAsset from "../../assets/gifs/404_error.mp4";
import { Launch } from "@mui/icons-material";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="not-found-container">
      <video className="not-found-video" src={videoAsset} autoPlay loop muted />
      <h1>Error 404 Not Found</h1>
      <h2>Oops! It seems you've ventured into uncharted territory.</h2>
      <button className="home-button" onClick={handleGoHome}>
        Go to Homepage
        <Launch style={{ fontSize: "20px", marginLeft: "8px" }} />
      </button>
    </div>
  );
};

export default NotFound;
